import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-cambiapassword',
  templateUrl: './cambiapassword.component.html',
  styleUrls: ['./cambiapassword.component.scss']
})
export class CambiapasswordComponent implements OnInit {

  oldPassword: string = '';
  newPassword: string = '';
  repeatPassword: string = '';
  email: string = '';
  usuario: any;

  constructor(private confirmationService: ConfirmationService, private messageService: MessageService,
    private formBuilder: FormBuilder, private http: HttpService,
    ) { }

  ngOnInit(): void {
    //Extrae el email desde los datos del usuario
    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))
    this.email = this.usuario.Email
  }

  cambiaPassword() {
    if (this.newPassword != this.repeatPassword) {
      this.messageService.add({
        severity: "warn",
        summary: "Uppps",
        detail: "La nueva contraseña no coincide con la repetición"
      });
      return;
    }

    this.http.updatePasswordService(this.email, this.newPassword, this.oldPassword).subscribe((data: any) => {
      console.log(data)
      this.messageService.add({
        severity: "success",
        summary: "Bien!",
        detail: "La contraseña se cambió con éxito"
      });
      this.limpiaFormulario()

    }, err => {
      this.messageService.add({
        severity: "error",
        summary: "Uppps",
        detail: err.error
      });
    })

  }

  limpiaFormulario() {
    this.oldPassword = ''
    this.newPassword = ''
    this.repeatPassword = ''
  }

}
